/// ////////////////////////////////////////////////////////////
/// ////////////////////// Mandarin ////////////////////////////
/// ////////////////////////////////////////////////////////////
import React from "react";

import { DASH_LINKS } from "@const/AppCardLinks";

export const data: Record<string, React.ReactNode> = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <b>EngagED家长门户登录流程（内部/外部）</b>,
    Interrupt_p1: (
        <>
            要登录 EngagED 家长门户，您需要将您的 <b>Infinite Campus 家长门户用户名</b>
            （外部家长：在设置帐户时创建的用户名） <u>和</u> <b>@p.dcsdk12.org</b> 配对。例如：如果您的 Infinite Campus
            用户名是 <b>jsmith</b>，您将在接下来的登录屏幕上输入 <b>jsmith@p.dcsdk12.org</b> 作为您的电子邮件地址。您的{" "}
            <b>密码</b> 与您访问 Infinite Campus 时使用的密码相同（外部家长：在设置帐户时创建的密码）。
        </>
    ),
    Interrupt_p2: (
        <>
            <b>如果您忘记了 DCSD 的登录凭证</b>:<br />
            使用这些链接来
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/forgotuserid.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                找回您的用户名
            </a>{" "}
            和/或
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/kiosk.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                重置您的密码
            </a>
            {"."}
        </>
    ),
    Interrupt_p3: (
        <>
            <b>如果您已按照上述步骤操作但仍然遇到困难，请联系我们</b>
            :<br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                家长技术支持 - 英文
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                家长技术支持 - 西班牙文
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                家长技术支持 - 中文
            </a>
            <br />
            IT支持中心电话 <b>303.387.0001</b>
        </>
    ),
    Interrupt_note: "注意：目前为人父母的学区员工应使用隐身或私密浏览窗口和/或不同的浏览器，按照上述说明进行操作。",
    Interrupt_submit: "继续登录",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "欢迎,",
    Main_Nav_HelpfulLinks: "有用的网址",
    Main_Nav_LogOut: "登出",
    Main_Nav_HelpfulLinks_LI_s1: "联系我的学生的护士",
    Main_Nav_HelpfulLinks_LI_s2: "学术日历",
    Main_Nav_HelpfulLinks_LI_s3: "家长资源",
    Main_Nav_HelpfulLinks_LI_s4: "公交路线",
    Main_Nav_HelpfulLinks_LI_s5: "在线支付",
    Main_Nav_HelpfulLinks_LI_s6: "午餐菜单",
    Main_Nav_Exit: "退出",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "添加",
    Global_Add_New_Student: "添加新学生",
    Global_Add_New_Student_For_Open_Enrollment: "为开放注册添加新学生",
    Global_BackToDashboard: "返回仪表板",
    Global_Dashboard: "仪表板",
    Global_Faq: "常见问题解答",
    Global_Close: "关闭",
    Global_Completed: "已完成",
    Global_Currently_Unavailable: "当前不可用",
    Global_InProgress: "进行中",
    Global_GoTo: "前往",
    Global_Loading: "请稍候，我们正在收集您的学生信息 ...",
    Global_MoreInfo: "更多信息",
    Global_No_Student_1: "欢迎来到 EngagED 家长门户",
    Global_No_Student_2: "抱歉，我们无法找到与您的账户关联的任何学生。",
    Global_No_Student_External: (
        <>
            如果您正在申请开放注册，请点击&ldquo;<strong>添加新学生</strong>&rdquo;{" "}
            按钮来添加您的学生。如果您正在为多名学生申请，您将单独添加每一位学生。
        </>
    ),
    Global_No_Student_Guardian: (
        <>
            如果您没有看到您的学生，并且他们目前就读于 DCSD 学校，请致电 <strong>303-387-0001</strong> 联系 IT
            支持中心。如果您的学生目前未就读于 DCSD 学校，并且您正在申请开放注册，请仅使用“<strong>添加新学生</strong>{" "}
            ”按钮添加您的学生。
        </>
    ),
    // Global_No_Student_Guardian2: (
    //     <>
    //         如果您没有看到您的学生，并且他们目前就读于 DCSD 学校，请致电 <strong>303-387-0001</strong> 联系 IT
    //         支持中心。如果您的学生目前未就读于 DCSD 学校，并且您正在申请开放注册，请仅使用“<strong>添加新学生</strong>
    //         ”按钮添加您的学生。
    //     </>
    // ),
    Global_Notice_Ae: "评估豁免将在", // <some date>
    Global_Notice_Bus: "交通服务将于", // <some date>
    Global_Notice_Check_Back: "请稍后回来查看。",
    Global_Notice_Oe: "开放注册将于", // <some date>
    Global_NotStarted: "未开始",
    Global_Open: "开放",
    Global_OpenFrom: "开放时间从 ", // [DATE] - [DATE]
    Global_Status: "状态",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD 监护人仪表板",
    Breadcrumb_Back: "DCSD EngagED 家长门户",
    Breadcrumb_EPR: "DCSD 存档 EPR",
    Breadcrumb_Translations: "翻译尚在实验阶段",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Broadcast ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Broadcast_Title: "展望未来:",
    Broadcast_Message: (
        <>
            请注意，由于DCSD IT团队将进行关键的数据中心迁移，所有DCSD家长工具（包括开放注册）将在{" "}
            <strong>11月22日星期六</strong>和<strong>11月23日星期日</strong>期间离线/不可用。
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Failure1: "抱歉，我们无法为该学生检索 EPR PDF",
    EPR_Failure2: "联系学区寻求支持时，请提供以下信息：",
    EPR_NoData: "未找到该学生的历史 EPR。",
    EPR_Success: "已为该学生成功检索到 EPR PDF。",
    EPR_Title: "归档的EPR资源",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// No Apps /////////////////////////////
    /// /////////////////////////////////////////////////////////
    NoApp_Body1: "所有申请窗口目前已关闭。",
    NoApp_Body2: "如果您认为有误，请联系学区寻求支持。",
    NoApp_Closed: "已关闭",
    NoApp_Header: "没有可用的申请",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Welcome Page ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Welcome_Header: "欢迎来到 DCSD 监护人仪表板",
    Welcome_Header_Alt: "欢迎来到积极参与型家长门户",
    Welcome_Tagline: "与家长合作，为每位学生选择最佳的学习环境。",
    Welcome_p1: (
        <p className="grey-text">
            我们赋能家庭，为他们的孩子找到最合适的教育方式。{" "}
            <a
                href="https://www.dcsdk12.org/schools-academics/schools/school-locator-map"
                rel="noreferrer"
                target="_blank"
            >
                了解更多
            </a>
        </p>
    ),
    Welcome_p2: (
        <p className="grey-text">
            希望让孩子入读非所属学区学校的家庭，必须使用此工具在 DCSD 每年提供的两个开放注册期之一申请开放注册 (Open
            Enrollment)。{" "}
            <span className="highlight">
                您无需使用此开放注册工具即可留在<b>当前注册</b>的学校。
            </span>
        </p>
    ),
    Welcome_h5_1: (
        <h5 className="grey-text">
            <a
                href="https://docs.google.com/document/d/1sr3ARzZGUmmJdNSjlWnLM0QWj8ipKHJb3RkwLr72_P0/edit"
                rel="noreferrer"
                target="_blank"
            >
                点击此处
            </a>{" "}
            获取有关如何使用该工具的分步说明。
        </h5>
    ),
    Welcome_ImportantDates: "重要日期/时间",
    Welcome_FirstWindow: "第一阶段",
    Welcome_SecondWindow: "第二阶段",
    Welcome_ul_li1a: "第一轮开放注册并非先到先得；您必须在 ", // [DATE]
    Welcome_ul_li1b: "之前完成此流程。",
    Welcome_ul_li2a: "对于第一轮，您可以在 ", // [DATE]
    Welcome_ul_li3: "之前随时更改您的开放注册申请选项。",
    Welcome_ul_li4a: "学校将根据空余学位情况向家庭发出录取通知。您在 ", // [DATE]
    Welcome_ul_li4b: (
        <>
            之后才能看到录取通知。您可以在或之后重新登录 <a href={DASH_LINKS.guardian}>EngagED 家长门户</a> ，日期为
        </>
    ), // [DATE]
    Welcome_ul_li4c: "查看您可能收到的任何录取通知。",
    Welcome_ul_li5a: "您必须在 ", // [DATE]
    Welcome_ul_li5b: (
        <>
            之前通过 <a href={DASH_LINKS.guardian}>EngagED 家长门户</a> 接受学校的开放注册录取通知。
        </>
    ),
    Welcome_ul_li6a:
        "如果您的开放注册申请未被任何学校接受，或者您未登录并接受录取通知，您将自动被列入第二轮开放注册的候补名单，该名单的有效期为 ", // [DATE RANGE]
    Welcome_Before_You_Begin: "在您开始之前",
    Welcome_Before_You_Begin_Body: (
        <>
            <div className="grey-text" style={{ fontWeight: "bold" }}>
                如果您的孩子曾经就读于 DCSD 学校，您已经拥有一个家长门户账户的用户名和密码。请{" "}
                <span className="text-danger">
                    <u>不要</u>
                </span>{" "}
                创建新账户，因为这可能会影响您学生的开放注册。如果您忘记了您的家长门户账户信息，请联系您目前就读的 DCSD
                学校或“选择课程办公室”以访问家长门户。
            </div>
            <h5 className="mt-3">家长/监护人请注意：</h5>
            <div className="grey-text">
                访问 EngagED 家长门户的登录流程最近有所变更。{" "}
                <b>
                    家长/监护人现在登录 EngagED 家长门户时，必须在当前用户名后添加 <u>@p.dcsdk12.org</u>
                </b>
                {"。 "}例如，如果您以前使用的用户名为 absmith，现在您将使用 absmith@p.dcsdk12.org
                作为您的用户名，您的学区密码未更改。
            </div>
            <div className="grey-text mt-3">
                如果您需要更改您的学区密码和/或管理您的账户，您可以在 DCSD 网站{" "}
                <a
                    href="https://www.dcsdk12.org/parents-students/resources/parent-it-support/password-reset"
                    rel="noreferrer"
                    target="_blank"
                >
                    此处
                </a>{" "}
                进行操作。如果您在使用上述新登录流程登录 EngagED 时遇到困难，请点击{" "}
                <a
                    href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                    rel="noreferrer"
                    target="_blank"
                >
                    此处
                </a>{" "}
                或致电 303-387-0001 联系 DCSD IT 部门。
            </div>
        </>
    ),
    Welcome_InfoFooter: (
        <>
            <em>
                如需更多信息，请联系<strong>选择课程办公室</strong>，电子邮件：
            </em>{" "}
            <a href="mailto:open-enrollmentusergroup@dcsdk12.org">open-enrollmentusergroup@dcsdk12.org</a>。
        </>
    ),
    Welcome_NotAvailable: "当前学年的开放注册流程尚不可用。",
    Welcome_PreschoolInfo: "幼儿园/学前班信息",
    Welcome_Note: "注意",
    Welcome_NoSupport: "本应用程序不支持申请 DCSD 学前班。",
    Welcome_PreschoolsLink: (
        <>
            有关 DCSD 学前班信息，请{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/preschool" rel="noreferrer" target="_blank">
                <strong>点击此链接</strong>。
            </a>
        </>
    ),
    Welcome_PreschoolEnrollment: (
        <>
            希望为三岁和四岁孩子报名入读学区学前班的家长无需通过开放注册。学前班注册将于一月初进行。请关注此{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/kindergarten" rel="noreferrer" target="_blank">
                <strong>链接</strong>
            </a>{" "}
            获取更多信息。
        </>
    ),
    Welcome_CharterSchoolInfo: "特许学校信息 (Charter School)",
    Welcome_CharterSchoolInclude: (
        <>
            <h5>以下特许学校今年将使用此工具：</h5>
            <a
                href="https://www.dcsdk12.org/schools_academics/schools/charter_schools"
                rel="noreferrer"
                target="_blank"
            >
                <u>请直接联系所有其他特许学校，了解有关特许学校入学选项的更多信息。</u>
            </a>
            <ul className="charter-school-li">
                <li>
                    <i>Aspen View Academy</i>
                </li>
                <li>
                    <i>Ben Franklin Academy</i>
                </li>
                <li>
                    <i>Challenge to Excellence</i>
                </li>
                <li>
                    <i>DCS Montessori Charter</i>
                </li>
                <li>
                    <i>Leman Academy of Excellence</i>
                </li>
                <li>
                    <i>Parker Performing Arts School</i>
                </li>
                <li>
                    <i>Platte River Academy</i>
                </li>
                <li>
                    <i>SkyView Academy</i>
                </li>
                <li>
                    <i>World Compass Academy</i>
                </li>
            </ul>
        </>
    ),
    Welcome_TransportationInfo: "交通信息",
    Welcome_TransportationBody: "获准在所属学区以外的学校或项目就读的本地学生的交通应由其家长/监护人负责。",
    Welcome_GeneralInfo: "一般信息",
    Welcome_GeneralInfo_ul2_li1: "您的请求提交后，我们将向您发送一封确认电子邮件。",
    Welcome_GeneralInfo_ul2_li3: (
        <>
            第二轮开放注册遵循&ldquo;先到先得&rdquo;原则。仅在第二轮申请开放注册的学生将被安排在候补名单上，排在第一轮候补名单上现有学生之后。
        </>
    ),
    Welcome_GeneralInfo_ul2_li4: (
        <>
            如果您已通过开放注册入读某学区学校或就读于特许学校，但希望在下一学年返回与您住址相关联的学区学校，您必须在{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                返校意向表
            </a>{" "}
            提交之前，日期为
        </>
    ), // [DATE],
    Welcome_GeneralInfo_li5: (
        <>
            如果您在学区内搬家但希望留在当前学校，您可以随时提交{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                留校意向
            </a>{" "}
            表。
        </>
    ),
    Welcome_Start_Here: "从这里开始",
    Welcome_New_To_District: "您是本学区的新生吗？",
    Welcome_No: "不",
    Welcome_Yes: "是",
    Welcome_U_And_P: "您有 EngagED 家长门户的用户名和密码吗？",
    Welcome_Log_In: "登录",
    Welcome_Contact_Choice_Programming: "请联系学生目前就读的学校，以获取有关创建DCSD家长门户账户的帮助。",
    Welcome_Create_Account: "创建新账户",
    Welcome_Caution:
        "* 注意：如果您目前在学区有学生，但登录 EngagED 家长门户时遇到问题，请不要创建新账户，因为这可能会导致您的开放注册申请作废！如果您需要登录当前 EngagED 家长门户账户的帮助，请联系您目前就读的 DCSD 学校或“选择课程办公室”。",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Marquee /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Marquee_Grade: "年级",
    Marquee_School: "学校",
    Marquee_Address: "地址",
    Marquee_NewStudent: "新生",
    Marquee_NotAvailable: "不可用",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment App /////////////////////
    /// /////////////////////////////////////////////////////////
    OEApp_Header: "开放注册 (Open Enrollment)",
    OEApp_Btn1: "开始开放注册",
    OEApp_Btn2: "管理学校选择",
    OEApp_Btn3: "查看学生信息",
    OEApp_Btn4: "编辑学生信息",
    OEApp_Btn5: "选择学校",
    OEApp_Btn6: "开放注册",
    OEApp_Btn7: "查看学校选项",
    OEApp_Btn8: "查看学校录取通知状态",
    OEApp_Btn9: "查看学校录取通知",
    OEApp_Schools: "已做出的学校选择",
    OEApp_School: "已做出的学校选择",
    OEApp_NoSchools: "未做学校选择",
    OEApp_1School: "1 个学校选择已做",
    OEApp_MoreSchools: "个学校选择已做",
    OEApp_SchoolsMakingOffers: "学校正在发出录取通知",
    OEApp_SchoolsFinalizingOffers: "学校正在敲定录取通知",
    OEApp_Body: "供家长为其学生选择入读 DCSD 学区学校和特许学校的申请流程。",
    OEApp_Round1: "第一轮",
    OEApp_Round2: "第二轮",
    OEApp_RoundClosed: "第一轮已结束。请在第二轮开始时回来，开始日期：", // [DATE]
    OEApp_SchoolChoices: "学校选择",
    OEApp_RequestStatus: "申请状态",
    OEApp_LanguageChoice: "语言选择",
    OEApp_KinderChoice: "幼儿园选择",
    OEApp_LanguageOffer: "语言录取",
    OEApp_KinderOffer: "幼儿园录取",
    OEApp_FullDay: "全天",
    OEApp_HalfDayPM: "半天下午班",
    OEApp_HalfDayAM: "半天上午班",
    OEApp_Spanish: "西班牙语",
    OEApp_Mandarin: "普通话",
    OEApp_French: "法语",
    OEApp_NotEligible: (
        <>
            根据学生的出生日期，该 <span className="age">学生的年龄不在开放注册的范围之内</span>
            {"。"}
            请联系“选择编程”部门讨论具体情况和/或开放注册的选项。
        </>
    ),
    OEApp_Ineligible: "不符合资格",
    OEApp_NewStudent: "新生",
    OEApp_ACCEPT_OFFER: "已接受录取",
    OEApp_CANCELLED_REQUEST: "已取消申请",
    OEApp_CHANGED_ENROLLMENT: "已退学",
    OEApp_CHOICE_CREATED: "已创建学校选择",
    OEApp_CHOICE_INCOMPLETE: "选择不完整",
    OEApp_DENY_OFFER: "已拒绝录取",
    OEApp_DENY_REQUEST: "已拒绝申请",
    OEApp_ENROLLED: "已注册",
    OEApp_INVALID: "无效",
    OEApp_MAKE_OFFER: "已发出录取通知",
    OEApp_MAKE_OFFER_PENDING: "待发出录取通知",
    OEApp_NO_RESPONSE: "无回应",
    OEApp_WAIT_LIST: "在候补名单上",
    OEApp_REQUEST: "已提出申请",
    OEApp_UNENROLLED: "已退学",
    OEApp_UNAVAILABLE: "不可用",
    /// /////////////////////////////////////////////////////////
    /// ///////////// Express Check-In App //////////////////////
    /// /////////////////////////////////////////////////////////
    ECApp_Header: "快速登记 (Express Check-In)",
    ECApp_Btn1: "快速办理入住",
    ECApp_Body: "年度学生登记流程，供家长更新和/或核实当前的家庭住址、媒体同意书、紧急联系人、健康状况等信息。",
    /// ////////////////////////////////////////////////////////
    /// ///////// Elementary Progress Report App ///////////////
    /// ////////////////////////////////////////////////////////
    EPRApp_Body: "社区小学生每半年度学业进展信息",
    EPRApp_NotReady: "您学生的成绩单尚未准备好。请联系您学生的学校以获取更多信息。",
    EPRApp_NotReleased: "未发布",
    EPRApp_Coming_Soon: "敬请期待",
    EPRApp_Available: "成绩单暂不可用。请于 ", // [some variable dateString] 起重新查看
    EPRApp_IsAvailable: "成绩单可用",
    EPRApp_NotAvailable: "不可用",
    EPRApp_Header: "小学成绩单",
    EPRApp_Btn1: "查看最新成绩单",
    EPRApp_Btn2: "查看存档成绩单",
    EPRApp_Semester: "学期",
    EPRApp_1stSemester: "第一学期",
    EPRApp_2ndSemester: "第二学期",
    EPRApp_SurveyLink: "完成家长EPR调查",
    EPRApp_SurveyHeadline: "EPR家长调查",
    EPRApp_SurveyDescription: "感谢您提前对学生进度报告提供反馈。",
    /// ////////////////////////////////////////////////////////
    /// /////////// Assessment Excusals App ////////////////////
    /// ////////////////////////////////////////////////////////
    AEApp_Body: "管理评估退出申请。",
    AEApp_Header: "评估豁免",
    AEApp_Excusal: "豁免",
    AEApp_Excusals: "豁免",
    AEApp_NoExcusals: "无豁免",
    AEApp_MoreExcusals: "条免考",
    AEApp_Btn1: "评估免考",
    /// ////////////////////////////////////////////////////////
    /// /////////////// Transportation App /////////////////////
    /// ////////////////////////////////////////////////////////
    BusApp_Body1: "每位公交乘客需向司机出示有效的公交卡。乘车费用将按季度按次收费。",
    BusApp_Body2: "申请公交卡",
    BusApp_Header: "交通",
    BusApp_Btn1: "交通",
    BusApp_BusPass: "已发放校车通行证",
    BusApp_NotIssued: "未发放公交卡",
    BusApp_NoBusPass: "您可以申请公交卡并获取更多有关交通的信息。",
    BusApp_NotRiding: "不乘坐校车",
    BusApp_NotRidingReason1: "您已表明 ", // [NAME]
    BusApp_NotRidingReason2: " 今年将不乘坐校车。",
    BusApp_NotRidingReason3: "您已表明该学生今年不乘坐校车",
    BusApp_Processing: "校车通行证处理中",
    BusApp_AnnualOffer: "年度通行证优惠截止日期 ", // [DATE]
    BusApp_Annual: "在上一次会话中，您选择了按年计费。",
    BusApp_Quarterly: "您已选择季度计费。您可以在 ", // [DATE]
    BusApp_BusPassIssued: "您学生的校车通行证已发放。",
    BusApp_BusPassIssued2: (
        <>
            如果公交卡损坏或丢失，可以通过{" "}
            <a
                className="anchor"
                href="https://www.onflo.com/Lets-Talk/FormBuilder/#/Dialogue?k=PG7KK3Z6DLT@WK3Z6DLT@MDLT@DY4N3T5LT@LDLT@NDLT"
                rel="noreferrer"
                target="_blank"
            >
                Onflo
            </a>{" "}
            申请补办。
        </>
    ),
    BusApp_BusPassProcessing: "您的公交卡申请仍在处理中。请稍后回来查看。",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Loading Messages ////////////////////////
    /// /////////////////////////////////////////////////////////
    Loading_1: "开放注册加载中",
    Loading_2: "快速登记加载中",
    Loading_3: "小学进度报告加载中",
    Loading_4: "评估豁免加载中",
    Loading_5: "交通加载中",
    Loading_6: "调查加载中",
    Loading_7: "广播消息加载中",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment Pending & Status ////////
    /// /////////////////////////////////////////////////////////
    OE_Pending_Desc_Pre: " ",
    OE_Pending_Desc_Post:
        " 学年的开放入学申请尚未开始。我们诚邀有意向的家庭和校外监护人了解 DCSD 学校，并为即将到来的入学申请做好准备。",
    OE_Pending_Begins: "开放入学申请将于 ",
    OE_Countdown_Opens_In: "距离开放还有 ",
    OE_Countdown_Day: "天",
    OE_Countdown_Days: "天",
    OE_Explore_Schools_Title: "探索 DCSD 学校",
    OE_Explore_Schools_Desc: "探索道格拉斯县学区周边的学区学校、特许学校及备选学校，为您的学生找到最佳学习环境。",
    OE_Explore_Schools_Btn: "探索学校选择 →",
    OE_Info_Title: "开放入学信息",
    OE_Info_Desc: "了解开放入学的申请时间表、申请流程、优先录取层级以及重要的学区截止日期。",
    OE_Info_Btn: "查看入学指南 →",
    OE_Help_Footer_Title: "已有学生在 DCSD 就读？",
    OE_Help_Footer_Desc:
        " 如果您的学生目前就读于 DCSD 学校，您已拥有家长门户账户。请使用您的监护人凭证登录，或联系学生当前所在学校寻求帮助。",
    OE_Guardian_No_Students_IT_Help: "如果您未看到您的学生，且他们目前已在 DCSD 学校就读，请联系 IT 支持中心：",
    OE_Notice_Header: "申请开放入学？",
    OE_Notice_Begins_Pre: " ",
    OE_Notice_Begins_Mid: " 学年的开放入学申请将于 ",
    OE_Notice_Subtext: "开放申请窗口开启后，上方将显示“添加新学生”按钮以提交您的申请。",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Error Messages //////////////////////////
    /// /////////////////////////////////////////////////////////
    Error_UserDetails_Title: "无法获取用户信息",
    Error_UserDetails_Sub: (
        <>
            从我们的系统中获取您的账户信息时出现问题。
            <br />
            对于给您带来的不便，我们深表歉意
        </>
    ),
    Error_UserDetails_Sync_Msg: "如果您是现任 DCSD 监护人，您的用户账户信息可能需要进一步的技术排查。",
    Error_UserDetails_Contact_Pre: (
        <>
            请联系 <strong>IT 支持中心</strong>，电话： <strong style={{ color: "#0669B3" }}>303-387-0001</strong>{" "}
            以获取进一步帮助。
        </>
    )
    /// /////////////////////////////////////////////////////////
};
